import React from 'react'
import {connect} from 'react-redux'
import {alertActions} from '../actions/alertActions'
import {userActions} from '../actions/userActions'
import {withRouter} from "react-router";
import Template from '../components/Template'
import {Route, Redirect, Switch} from 'react-router-dom';
import {ROUTES} from "../constants/routes";
import Error404 from "../components/Error404";
import LoginPage from "../components/LoginPage";



class App extends React.Component {
    constructor(props) {
        super(props);
        //czyścimy komunikaty przy przeładowaniu adresu
        props.history.listen((location, action) => {
            this.props.clearAlerts();
        });
    }

    render() {


    return (
        <Switch>
            <Route exact path="/">
                 <Redirect to="/pl" />
            </Route>

            {ROUTES
                .filter((row) => {
                    return row.loginRequired === this.props.isLoggedIn || row.loginRequired === 'both';
                })
                .map((element, index) => {
                    let Component = element.component;
                    return<Route
                        key={index}
                        path={"/:lang" + element.path}
                        exact={typeof element.exact === 'undefined' ? false : element.exact}
                        render={({ match }) => {
                            global.lang = match.params.lang;
                            if (element.withoutTemplate) {
                                return <Component match={match}/>
                            }
                            return <Template><Component match={match}/> </Template>
                        }}
                        />
                })
            }


            { /* To prevent the error page from being displayed, when the user was  already authenticated */ }
            {this.props.isLoggedIn && (
                <Route path={"/:lang//hash-login/:hash"} >
                    <Redirect to="/pl" />
                </Route>
            )}
            {this.props.isLoggedIn ? (
                <Route path={"/:lang"} render={({ match }) => {global.lang = match.params.lang; return <Template><Error404 match={match}/> </Template>}}  />
            ) : (
                <Route path={"/:lang"} render={({ match }) => {global.lang = match.params.lang; return <LoginPage />}}  />
            )}

        </Switch>
    )
  }
}





const actionCreators = {
  clearAlerts: alertActions.clear,
  getUserInfo: userActions.getInfo
};

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
    };
};

export default connect(mapStateToProps, actionCreators)(withRouter(App));
